import { useEffect, useState } from 'react';
import { useQuery } from 'react-apollo';
import { path } from 'ramda';
import gql from 'graphql-tag';

import { GET_PROFILE } from 'components/UserMgmt/UserMgmt.queries';
import { splitIO } from 'state/splitio';

type SplitioQuery = {
  data: { splitioEvent?: SplitIO.Event };
};

enum Treatment {
  ON = 'on',
  OFF = 'off',
  CONTROL = 'control',
}

enum SplitIOEvent {
  SDK_READY = 'init::ready',
}

const GET_SPLITIO_EVENT = gql`
  {
    splitioEvent @client
  }
`;

const useSplitIO = (feature: string) => {
  const [status, setStatus] = useState<boolean>(false);
  const splitioPayload = useQuery<SplitioQuery>(GET_SPLITIO_EVENT);
  const profilePayload = useQuery(GET_PROFILE);

  const splitioEvent = path(['data', 'splitioEvent'], splitioPayload);

  useEffect(() => {
    if (splitioEvent === SplitIOEvent.SDK_READY) {
      const profile = path(['data', 'userProfile'], profilePayload);
      const client = splitIO.getClient() as SplitIO.IClient;

      const treatment = client.getTreatment(
        feature,
        profile as SplitIO.Attributes,
      );

      if (treatment === Treatment.ON) {
        setStatus(true);
      }

      if (treatment === Treatment.OFF) {
        setStatus(false);
      }
    }
  }, [splitioEvent]);

  return { status };
};

export { useSplitIO };
